






/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETUSERANDCONNECTIONSFEEDSWITHLIKEWITHCOMMENT= createAsyncThunk(
  "getUserAndConnectionsFeedsWithLikeWithComment/getUserAndConnectionsFeedsWithLikeWithComment",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getUserAndConnectionsFeedsWithLikeWithCommentSlice = createSlice({
  name: "getUserAndConnectionsFeedsWithLikeWithCommentSlice",
  initialState: {
    getUserAndConnectionsFeedsWithLikeWithComment: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetUserAndConnectionsFeedsWithLikeWithComment: (state) => {
        state.getUserAndConnectionsFeedsWithLikeWithComment.loading = false
        state.getUserAndConnectionsFeedsWithLikeWithComment.error = false
        state.getUserAndConnectionsFeedsWithLikeWithComment.data = []
        state.getUserAndConnectionsFeedsWithLikeWithComment.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETUSERANDCONNECTIONSFEEDSWITHLIKEWITHCOMMENT.fulfilled, (state, action) => {
      state.getUserAndConnectionsFeedsWithLikeWithComment = {
        ...state.getUserAndConnectionsFeedsWithLikeWithComment,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUSERANDCONNECTIONSFEEDSWITHLIKEWITHCOMMENT.pending, (state, action) => {
      state.getUserAndConnectionsFeedsWithLikeWithComment = {
        ...state.getUserAndConnectionsFeedsWithLikeWithComment,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUSERANDCONNECTIONSFEEDSWITHLIKEWITHCOMMENT.rejected, (state, action) => {
      state.getUserAndConnectionsFeedsWithLikeWithComment = {
        ...state.getUserAndConnectionsFeedsWithLikeWithComment,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getUserAndConnectionsFeedsWithLikeWithCommentAction = {
    GETUSERANDCONNECTIONSFEEDSWITHLIKEWITHCOMMENT,
};

export { getUserAndConnectionsFeedsWithLikeWithCommentAction };
export default getUserAndConnectionsFeedsWithLikeWithCommentSlice.reducer;
export const {setInitialStateOfgetUserAndConnectionsFeedsWithLikeWithComment} = getUserAndConnectionsFeedsWithLikeWithCommentSlice.actions
